import { CommonModule, NgFor } from '@angular/common'
import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { eps } from '../../../../services/url.service'
import {
  distinctUntilChanged,
  EMPTY,
  filter,
  Observable,
  startWith,
  Subject,
  switchMap,
  take,
  takeUntil,
  tap
} from 'rxjs'
import { select, Store } from '@ngrx/store'
import { payrollSummaryActions } from '../../../../store/payroll/payroll.actions'
import { selectPayrollSummary } from '../../../../store/payroll/payroll.reducers'
import { selectSelectedUser } from '../../../../store/user/user.reducer'
import { loadUserById } from '../../../../store/user/user.actions'
import { User } from '../../../../store/auth/auth.state'
import { PayrollSummaryService } from '../../../../services/payroll-summary.service'
import { PayrollSummary } from '../../../../store/payroll/payroll.state'
import {
  ContractorPayrollSummaryService,
  PayrollHistoryResponse
} from '../../../../services/contractor-payroll-summary.service'

@Component({
  selector: 'app-contractor-payroll-summary',
  imports: [NgFor, CommonModule, RouterModule, ReactiveFormsModule],
  templateUrl: './contractor-payroll-summary.component.html',
  styleUrl: './contractor-payroll-summary.component.scss'
})
export class ContractorPayrollSummaryComponent implements OnInit, OnDestroy {
  private store = inject(Store)
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private destroy$ = new Subject<void>()
  eps = eps
  employeeId = ''
  employeeName = ''
  joiningDate!: any
  belongsTo = ''
  financialYears: string[] = []
  selectedFinancialYear = new FormControl('', { nonNullable: true })
  payrollSummary$!: Observable<PayrollHistoryResponse>
  private contractorPayrollSummaryService = inject(ContractorPayrollSummaryService)

  ngOnInit(): void {
    const employeeId = this.route.snapshot.paramMap.get('id')
    if (employeeId) this.employeeId = employeeId
    else this.router.navigate([eps.hrm.employeePath, this.employeeId])

    this.store.dispatch(loadUserById({ id: this.employeeId }))
    this.listenForSelectionChanges()
    this.getFinancialYearsList(this.employeeId)
    this.setEmployeeNameAndJoiningDate()

    //this.payrollSummary$ = this.selectedFinancialYear.valueChanges.pipe(
    //  filter(year => !!year && !!this.belongsTo),
    //  distinctUntilChanged(),
    //  switchMap(year => {
    //    if (!this.belongsTo) {
    //      return EMPTY;
    //    }
    //    return this.contractorPayrollSummaryService.loadSummary(
    //      this.employeeId,
    //      year,
    //      this.belongsTo
    //    )
    //  }),
    //  takeUntil(this.destroy$)
    //)
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  private setEmployeeNameAndJoiningDate(): void {
    this.store
      .pipe(
        select(selectSelectedUser),
        filter((user): user is User => !!user),
        take(1)
      )
      .subscribe(user => {
        this.employeeName = user.firstName + ' ' + (user.lastName ?? '')
        this.belongsTo = user.businessId
        this.joiningDate = user.joiningDate
      })
  }

  private listenForSelectionChanges(): void {
    this.payrollSummary$ = this.selectedFinancialYear.valueChanges.pipe(
      filter(year => !!year && !!this.belongsTo),
      distinctUntilChanged(),
      switchMap(year =>
        this.contractorPayrollSummaryService.loadSummary(this.employeeId, year, this.belongsTo)
      ),
      takeUntil(this.destroy$)
    )
  }

  getFinancialYearsList(employeeId: string) {
    this.contractorPayrollSummaryService
      .getFinancialYears(employeeId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          this.financialYears = response
        },
        error: (error: { message: string }) => {
          console.warn('Error: ' + error.message)
        }
      })
  }
}
